import { BsX } from 'react-icons/bs'
import FiltersGroup from '../FiltersGroup'
import './index.css'

const FilterDrawer = props => {
  const { isOpen, onClose, ...filterProps } = props

  return (
    <>
      <div
        className={`filter-drawer-backdrop ${isOpen ? 'open' : ''}`}
        onClick={onClose}
      />
      <div className={`filter-drawer ${isOpen ? 'open' : ''}`}>
        <div className="filter-drawer-header">
          <h2>Filters</h2>
          <button type="button" className="drawer-close-btn" onClick={onClose}>
            <BsX size={24} />
          </button>
        </div>
        <div className="filter-drawer-content">
          <FiltersGroup {...filterProps} />
        </div>
        <div className="filter-drawer-footer">
          <button type="button" className="apply-btn" onClick={onClose}>
            Apply Filters
          </button>
        </div>
      </div>
    </>
  )
}

export default FilterDrawer
